/* 7 A.M. — Suscripción. Configurador de una vista: una tarjeta por café.
   El usuario incluye uno o varios cafés y ajusta formato, molienda, cantidad y
   frecuencia de cada uno. Al suscribirse se añaden todas las líneas al carrito
   (cada una con su selling_plan + propiedades) y se abre el cart-drawer del tema. */
(function () {
  "use strict";

  function init(root) {
    var dataEl = root.querySelector("[data-sub-data]");
    if (!dataEl) return;
    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!DATA.cafes || !DATA.cafes.length) return;

    var CUR = DATA.currency || "€";

    function money(c) { return CUR + (Number(c) / 100).toFixed(2).replace(".", ","); }
    function money0(c) { return CUR + Math.round(Number(c) / 100); }
    function setAll(sel, text) { root.querySelectorAll(sel).forEach(function (el) { el.textContent = text; }); }
    function setAllHTML(sel, html) { root.querySelectorAll(sel).forEach(function (el) { el.innerHTML = html; }); }

    function cafeByLabel(label) {
      return DATA.cafes.find(function (c) { return c.label === label; }) || DATA.cafes[0];
    }
    function variantOf(c, formato) {
      var vs = (c && c.variants) || [];
      return vs.find(function (v) { return v.formato === formato; }) || vs[0];
    }
    function plansOf(v) { return (v && v.plans) || []; }
    function grindsOf(c) { return (c && c.grinds && c.grinds.length) ? c.grinds : (DATA.grinds || []); }

    // Estado por café (clave = label). Por defecto todos desactivados; el usuario
    // activa los que quiera (mínimo 1 para poder suscribirse; el CTA se habilita
    // cuando hay al menos un café incluido).
    var state = {};
    DATA.cafes.forEach(function (c, i) {
      var v0 = (c.variants || [])[0];
      state[c.label] = {
        included: false,
        formato: v0 ? v0.formato : "",
        grind: grindsOf(c)[0] || "",
        units: 1,
        planIndex: 0,
      };
    });

    // Café cuyo panel de ajustes se ve: uno a la vez, con pestañas si hay más
    // de uno incluido (igual en móvil y en escritorio).
    var active = null;

    function planFor(c, s) {
      var pl = plansOf(variantOf(c, s.formato));
      return pl[Math.min(s.planIndex, pl.length - 1)] || null;
    }

    function priceFor(c, s) {
      var v = variantOf(c, s.formato), plan = planFor(c, s);
      var perBag = plan ? plan.price : (v ? v.price : 0);
      var compareBag = plan ? (plan.compare || (v ? v.price : 0)) : (v ? v.price : 0);
      var perDelivery = perBag * s.units, subtotal = compareBag * s.units;
      var perYear = plan ? plan.perYear : 12;
      return {
        v: v, plan: plan, perBag: perBag, perDelivery: perDelivery,
        subtotal: subtotal, discount: subtotal - perDelivery,
        annual: (subtotal - perDelivery) * perYear,
        valid: !!(v && v.available && plan),
      };
    }

    var cards = Array.prototype.slice.call(root.querySelectorAll("[data-cafecard]"));
    var picks = Array.prototype.slice.call(root.querySelectorAll("[data-cafe-label]"));
    var tabs = Array.prototype.slice.call(root.querySelectorAll("[data-mtab]"));

    function renderCard(card) {
      var label = card.getAttribute("data-cafecard");
      var c = cafeByLabel(label), s = state[label];
      if (!c || !s) return;

      card.classList.toggle("is-on", s.included);
      card.classList.toggle("is-cur", label === active);
      var body = card.querySelector("[data-cafe-body]"); if (body) body.hidden = !s.included;
      var toggle = card.querySelector("[data-cafe-toggle]"); if (toggle) toggle.setAttribute("aria-pressed", s.included ? "true" : "false");

      // Formato (precio por bolsa según el plan elegido)
      card.querySelectorAll("[data-cafe-formats] [data-format]").forEach(function (b) {
        var fval = b.getAttribute("data-format");
        b.classList.toggle("is-sel", fval === s.formato);
        var v = variantOf(c, fval), pl = plansOf(v), plan = pl[Math.min(s.planIndex, pl.length - 1)];
        var perBag = plan ? plan.price : (v ? v.price : 0);
        var was = plan ? (plan.compare || (v ? v.price : 0)) : (v ? v.price : 0);
        var pe = b.querySelector("[data-fmt-price]"); if (pe) pe.textContent = money(perBag);
        var we = b.querySelector("[data-fmt-was]");
        if (we) { if (was > perBag) { we.textContent = money(was); we.hidden = false; } else { we.hidden = true; } }
      });

      // Cantidad
      var qv = card.querySelector("[data-qty-val]"); if (qv) qv.textContent = s.units;
      var qw = card.querySelector("[data-qty-word]"); if (qw) qw.textContent = s.units === 1 ? "bolsa" : "bolsas";
      var minus = card.querySelector("[data-qty-minus]"), plus = card.querySelector("[data-qty-plus]");
      if (minus) minus.disabled = s.units <= 1;
      if (plus) plus.disabled = s.units >= 6;
      var p = priceFor(c, s);
      var qh = card.querySelector("[data-cafe-qtyhint]");
      if (qh) qh.innerHTML = "<b>" + s.units + " × " + s.formato + "</b> por envío · " + money(p.perDelivery);

      // Molienda
      card.querySelectorAll("[data-cafe-grinds] [data-grind-val]").forEach(function (b) {
        b.classList.toggle("is-sel", b.getAttribute("data-grind-val") === s.grind);
      });

      // Frecuencia (precio por envío = precio del plan × cantidad)
      card.querySelectorAll("[data-cafe-freqs] [data-freq-index]").forEach(function (b) {
        var i = parseInt(b.getAttribute("data-freq-index"), 10);
        b.classList.toggle("is-sel", i === s.planIndex);
        var v = variantOf(c, s.formato), plan = plansOf(v)[i];
        var se = b.querySelector("[data-freq-short]");
        if (se) se.textContent = plan ? (plan.short || plan.label) : "";
        var pe = b.querySelector("[data-freq-price]"), fe = b.querySelector("[data-freq-foot]");
        if (plan) {
          if (pe) pe.textContent = money(plan.price * s.units);
          var disc = (v.price - plan.price) * s.units * plan.perYear;
          if (fe) fe.textContent = plan.perYear + " envíos/año · ahorras " + money0(disc > 0 ? disc : 0);
        } else {
          if (pe) pe.textContent = "—";
          if (fe) fe.textContent = "";
        }
      });

      var hp = card.querySelector("[data-cafe-headprice]");
      if (hp) hp.textContent = s.included ? (money(p.perDelivery) + " / envío") : "";
    }

    function renderSummary() {
      var subtotal = 0, total = 0, annual = 0, anyIncluded = false, allValid = true;
      var rows = [];
      DATA.cafes.forEach(function (c) {
        var s = state[c.label];
        if (!s.included) return;
        anyIncluded = true;
        var p = priceFor(c, s);
        if (!p.valid) allValid = false;
        subtotal += p.subtotal; total += p.perDelivery; annual += p.annual;
        rows.push({ label: c.label, units: s.units, formato: s.formato, planLabel: p.plan ? p.plan.label : "—", perDelivery: p.perDelivery });
      });

      root.querySelectorAll("[data-sum-rows]").forEach(function (host) {
        host.innerHTML = "";
        if (!rows.length) {
          var empty = document.createElement("div");
          empty.className = "summary__row";
          empty.innerHTML = "<span class='k'>Elige al menos un café</span><span class='v'></span>";
          host.appendChild(empty);
          return;
        }
        rows.forEach(function (r) {
          var div = document.createElement("div");
          div.className = "summary__row";
          var k = document.createElement("span"); k.className = "k";
          k.textContent = r.label + " · " + r.units + " × " + r.formato + " · " + String(r.planLabel).toLowerCase();
          var v = document.createElement("span"); v.className = "v";
          v.textContent = money(r.perDelivery);
          div.appendChild(k); div.appendChild(v);
          host.appendChild(div);
        });
      });

      setAll("[data-sum-subtotal]", money(subtotal));
      setAll("[data-sum-discount]", "−" + money(subtotal - total));
      setAll("[data-sum-total]", money(total));
      setAllHTML("[data-sum-annual]", "Ahorras <b>" + money0(annual > 0 ? annual : 0) + " al año</b>");
      setAll("[data-mbar-total]", money(total));
      setAll("[data-mbar-save]", "−" + money(subtotal - total));

      var ok = anyIncluded && allValid;
      root.querySelectorAll("[data-subscribe], [data-mbar-cta]").forEach(function (b) { b.disabled = !ok; });
    }

    // Selector de cafés y pestañas
    function renderPicker() {
      var on = DATA.cafes.filter(function (c) { return state[c.label].included; });
      picks.forEach(function (b) {
        var label = b.getAttribute("data-cafe-label");
        var c = cafeByLabel(label), s = state[label];
        if (!s) return;
        b.classList.toggle("is-on", s.included);
        b.setAttribute("aria-pressed", s.included ? "true" : "false");
        // "Desde": primer formato y primer plan.
        var v = (c.variants || [])[0], plan = plansOf(v)[0];
        var fe = b.querySelector("[data-mpick-from]");
        if (fe) fe.textContent = money(plan ? plan.price : (v ? v.price : 0));
      });
      tabs.forEach(function (t) {
        var label = t.getAttribute("data-mtab");
        t.hidden = !(state[label] && state[label].included);
        t.classList.toggle("is-cur", label === active);
        t.setAttribute("aria-selected", label === active ? "true" : "false");
      });
      root.classList.toggle("has-sel", on.length > 0);
      root.classList.toggle("is-multi", on.length > 1);
    }

    // Filas por café de la hoja móvil y del resumen de escritorio.
    function renderSheetRows() {
      root.querySelectorAll("[data-msheet-rows]").forEach(function (host) {
        host.innerHTML = "";
        DATA.cafes.forEach(function (c) {
          var s = state[c.label];
          if (!s.included) return;
          var p = priceFor(c, s);
          var row = document.createElement("div"); row.className = "msheet__row";
          var l = document.createElement("span"); l.className = "msheet__row-l";
          var k = document.createElement("span"); k.className = "msheet__row-k"; k.textContent = c.short || c.label;
          var d = document.createElement("span"); d.className = "msheet__row-d";
          d.textContent = [s.units + " × " + s.formato, s.grind, p.plan ? (p.plan.every || String(p.plan.label).toLowerCase()) : "—"].join(" · ");
          l.appendChild(k); l.appendChild(d);
          var v = document.createElement("span"); v.className = "msheet__row-v"; v.textContent = money(p.perDelivery);
          row.appendChild(l); row.appendChild(v);
          host.appendChild(row);
        });
      });
    }

    function render() { cards.forEach(renderCard); renderPicker(); renderSummary(); renderSheetRows(); }

    function setIncluded(label, on) {
      var s = state[label];
      if (!s) return;
      s.included = on;
      if (on) { active = label; return; }
      if (active === label) {
        var other = DATA.cafes.find(function (c) { return state[c.label].included; });
        active = other ? other.label : null;
      }
    }

    // ---- Interacción ----
    root.addEventListener("click", function (e) {
      var t = e.target.closest(
        "[data-cafe-toggle],[data-mtab],[data-format],[data-grind-val],[data-freq-index],[data-qty-minus],[data-qty-plus],[data-subscribe],[data-mbar-cta],[data-mbar-expand],[data-msheet-close],[data-faq-q]"
      );
      if (!t || !root.contains(t)) return;

      var card = t.closest("[data-cafecard]");
      var label = card ? card.getAttribute("data-cafecard") : t.getAttribute("data-cafe-label");
      var s = label ? state[label] : null;

      if (t.hasAttribute("data-cafe-toggle")) {
        if (s) setIncluded(label, !s.included);
        render(); return;
      }
      if (t.hasAttribute("data-mtab")) { active = t.getAttribute("data-mtab"); render(); return; }
      if (s && t.hasAttribute("data-format")) {
        s.formato = t.getAttribute("data-format");
        var n = plansOf(variantOf(cafeByLabel(label), s.formato)).length;
        s.planIndex = n > 0 ? Math.min(s.planIndex, n - 1) : 0;
        render(); return;
      }
      if (s && t.hasAttribute("data-grind-val")) { s.grind = t.getAttribute("data-grind-val"); render(); return; }
      if (s && t.hasAttribute("data-freq-index")) { s.planIndex = parseInt(t.getAttribute("data-freq-index"), 10); render(); return; }
      if (s && t.hasAttribute("data-qty-minus")) { if (s.units > 1) { s.units--; render(); } return; }
      if (s && t.hasAttribute("data-qty-plus")) { if (s.units < 6) { s.units++; render(); } return; }

      if (t.hasAttribute("data-mbar-expand")) { openSheet(); return; }
      if (t.hasAttribute("data-msheet-close")) { closeSheet(); return; }
      if (t.hasAttribute("data-faq-q")) { toggleFaq(t); return; }
      if (t.hasAttribute("data-subscribe") || t.hasAttribute("data-mbar-cta")) { e.preventDefault(); subscribe(t); return; }
    });

    // ---- Carrito ----
    function buildProps(label, s) {
      var props = { "Molienda": s.grind };
      if (DATA.cafes.length > 1) props["Preparación"] = label;
      props["Suscripción"] = "Último lote";
      return props;
    }

    function collectItems() {
      var items = [];
      DATA.cafes.forEach(function (c) {
        var s = state[c.label];
        if (!s.included) return;
        var v = variantOf(c, s.formato), plan = planFor(c, s);
        if (!v || !plan) return;
        items.push({ id: v.id, quantity: s.units, selling_plan: plan.id, properties: buildProps(c.label, s) });
      });
      return items;
    }

    // Hay un aviso en el resumen de escritorio y otro en la barra móvil.
    function showError(msg) {
      root.querySelectorAll("[data-sub-error]").forEach(function (el) { el.textContent = msg; el.hidden = false; });
    }

    function subscribe(btn) {
      var items = collectItems();
      if (!items.length) return;
      root.querySelectorAll("[data-sub-error]").forEach(function (el) { el.hidden = true; });
      if (btn) { btn.disabled = true; btn.classList.add("loading"); }

      var cart = document.querySelector("cart-drawer");
      var body = { items: items };
      if (cart && typeof cart.getSectionsToRender === "function") {
        try {
          body.sections = cart.getSectionsToRender().map(function (sec) { return sec.id; }).join(",");
          body.sections_url = window.location.pathname;
        } catch (e) {}
      }
      var url = (window.routes && window.routes.cart_add_url) || "/cart/add";
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: JSON.stringify(body),
      })
        .then(function (r) {
          return r.json().catch(function () { return null; }).then(function (resp) { return { ok: r.ok, resp: resp }; });
        })
        .then(function (res) {
          var resp = res.resp;
          // Shopify puede responder con error (422, 400…) con o sin "status":
          // en ese caso se avisa y no se abre el carrito.
          if (!res.ok || !resp || resp.status || (resp.errors && !resp.items)) {
            var msg = resp && (resp.description || resp.message || resp.errors);
            showError(typeof msg === "string" && msg ? msg : "No se pudo añadir al carrito.");
            return;
          }
          closeSheet();
          if (cart && typeof cart.renderContents === "function") { try { cart.renderContents(resp); } catch (e) {} }
          if (cart && typeof cart.onShowCartDrawer === "function") {
            cart.onShowCartDrawer({ preventDefault: function () {} });
          } else {
            window.location = (window.routes && window.routes.cart_url) || "/cart";
          }
        })
        .catch(function () {
          window.location = (window.routes && window.routes.cart_url) || "/cart";
        })
        .then(function () { if (btn) { btn.disabled = false; btn.classList.remove("loading"); } });
    }

    // ---- FAQ + hoja móvil ----
    function toggleFaq(btn) {
      var item = btn.closest(".subfaq__item");
      if (!item) return;
      var wasOpen = item.classList.contains("is-open");
      root.querySelectorAll(".subfaq__item").forEach(function (it) { it.classList.remove("is-open"); });
      if (!wasOpen) item.classList.add("is-open");
    }
    var sheet = root.querySelector("[data-msheet]");
    function openSheet() { if (!sheet) return; sheet.classList.add("is-shown"); requestAnimationFrame(function () { sheet.classList.add("is-open"); }); }
    function closeSheet() { if (!sheet) return; sheet.classList.remove("is-open"); setTimeout(function () { sheet.classList.remove("is-shown"); }, 240); }
    if (sheet) sheet.addEventListener("click", function (e) { if (e.target === sheet) closeSheet(); });

    render();
  }

  function boot() { document.querySelectorAll("[data-sub-wizard]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
